const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/rmcallback/api-factory');
const serviceFactory = require('../resources/rmcallback/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/crmintegration/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app

//get daily statements 
  .match(`${p}callback.getResponseJson[{keys:portfolioId}][{keys:screen}][{keys:context}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getResponseJson(req.params)
       .then(response => res.value(response))
       .catch(res.error)
   )))
   .match(`${p}callback.getResponseJson[{keys:portfolioId}][{keys:screen}][{keys:context}][{keys:investmentIdeaId}][{keys:cache}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getResponseJsonExtended(req.params)
       .then(response => res.value(response))
       .catch(res.error)
   )));
}

module.exports = addRoutes;
